<template>
    <el-main class="market-page" v-if="isActive" v-wechat-title="$route.meta.title">
        <el-main>
            <div class="market-title column-header clearfloat">
                <span>行情</span>
                <div class="title-btn">
                    <select v-model="aBourseSelect">
                        <option value="1">okex</option>
                        <option value="2">火币</option>
                    </select>
                    <select v-model="bBourseSelect">
                        <option value="1">okex</option>
                        <option value="2">火币</option>
                    </select>
                    <el-button class="btn__style" title="添加表格" @click="addTable"><i class="fa fa-plus-square" aria-hidden="true"> 添加</i></el-button>
                </div>
            </div>
            <div class="market-table" v-if="tableDatas">
                <el-row v-if="tableWidth == 8">
                    <el-col :span="8" class="table-container" v-for="(table, index) in tableDatas" :key="index">
                        <MarketTable :tableData="table" :tableParam="changeData(index)"></MarketTable>
                    </el-col>
                </el-row>
                <el-row v-else-if="tableWidth == 12">
                    <el-col :span="12" class="table-container" v-for="(table, index) in tableDatas" :key="index">
                        <MarketTable :tableData="table" :tableParam="changeData(index)"></MarketTable>
                    </el-col>
                </el-row>
                <el-row v-else-if="tableWidth == 24">
                    <el-col :span="24" class="table-container" v-for="(table, index) in tableDatas" :key="index">
                        <MarketTable :tableData="table" :tableParam="changeData(index)"></MarketTable>
                    </el-col>
                </el-row>
            </div>
            <div class="market-table loading" v-else>
                <i class="el-icon-loading"></i> 加载中...
            </div>
        </el-main>
    </el-main>
</template>

<script>
/* eslint-disable */
import MarketTable from '@/views/market/Market-table.vue'
import { mapState, mapActions } from 'vuex'
import { get, put } from '@/api/index'
// import BtcSocket from "@/utils/mySocket";

export default {
    components: {
        MarketTable
    },
    data(){
        return {
            isActive: true,
            tableWidth: 8,
            aBourseSelect: 1,
            bBourseSelect: 2,
            // marketSocket: null,
            tableDatas: null,
        }
    },
    mounted() {
        this.init_();
    },
    computed: {
        ...mapState([
            'token',
            'marketSocket',
            'marketParam',
            'tableParamData',
            'marketTableList'
        ])
    },
    beforeDestroy() {
        if (this.marketSocket.sk) {
            this.marketSocket.sk.close();
            this.marketSocket.sk = null;
        }
    },
    inject: ['reload'],
    methods: {
        ...mapActions([
            'changeMarketParam',
            'getMarketParam1'
        ]),

        init_() {
            // 获取行情参数
            this.getMarketParam1();
            this.createSocket();

            // 监听窗口宽度
            this.getBroserWidth();
            window.onresize = () => {
                this.getBroserWidth();
            };
        }, 

        // 数据处理
        changeData(index) {
            var index_arr = index.split('e')[1];
            return index_arr;
        },

        // 添加表格
        addTable() {
            var tableDataArr = [Number(this.aBourseSelect), Number(this.bBourseSelect), 1, 2];
            this.marketTableList.push(tableDataArr);
            var param = {
                'token': this.token,
                'params': this.marketTableList
            };
            this.changeMarketParam2(param);
        },

        // websocket 初始化
        createSocket() {
            let url = 'ws://107.149.104.7/Service/market/get2?token='+this.token;

            if (!this.marketSocket.sk) {
                this.marketSocket.sk = new WebSocket(url);
            }
            this.listenSocket();
        },

        // 监听 websocket
        listenSocket() {
            this.marketSocket.sk.onopen = this.socketOpen;
            this.marketSocket.sk.onmessage = this.getMessage;
            this.marketSocket.sk.onclose = this.socketClose;
        },

        getMessage(res) {
            let tableList = JSON.parse(res.data).data;
            this.tableDatas = tableList;
        },

        socketOpen(e) {
            console.info('socket 已连接! 当前状态：', e.target.readyState);
        },

        socketClose(err) {
            console.warn('socket 已断开! 当前状态：',  err.target.readyState, err.reason);
        },

        // 获取浏览器宽度
        getBroserWidth() {
            var browserWidth = document.body.clientWidth;
            if (browserWidth < 1500) {
                // 浏览器宽度小于900px
                this.tableWidth = 12;
            } 
            if (browserWidth < 900) {
                this.tableWidth = 24;
            }
            if (browserWidth >= 1900) {
                this.tableWidth = 8;
            }
        },

        // 修改行情参数
        changeMarketParam2(param) {
            var url = this.$baseUrl + '/market/put2';
            put(url, param).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
    html{
        // font-size: 4vw;
        font-size: 14px;
    }
    .market-page{
        .el-main{
            // padding: 15px 0;
            // margin-bottom: 40px;
            min-height: 680px;
            background-color: #252425;
            .market-title{
                background-color:#1e1e1e;
                padding: 5px 10px;
                border-radius: 5px;
                border-bottom: 1px solid #1e1e1e;
                display: flex;
                justify-content: flex-start;
                h3{
                    display: flex;
                    align-items: center;
                    color: #A7A7A7;
                    padding: 5px;
                }
                .title-btn{
                    
                    padding: 3px;
                    display: flex;
                    justify-content: space-between;
                    select{
                        padding: 5px 5px;
                        font-size: 14px;
                        background-color: #333333;
                        border-color: #333333;
                        border-radius: 3px;
                        margin-left: 10px;
                        vertical-align:middle;
                        color: #a8a7a9;
                    }
                    .el-button{
                        padding: 5px 10px;
                        background-color: #333333;
                        border-color: #333333;
                        margin-left: 10px;
                        font-size: 14px;
                        color: #a8a7a9;
                    }
                    .el-button:hover{
                        color: aliceblue;
                    }
                    .el-button:focus{
                        color: aliceblue;
                    }   
                }
            }
            .market-table{
                background-color: #2A2D2E;
                border-radius: 5px;
                padding: 5px 0;
                padding-bottom: 10px;
                display: flex;
                justify-content: flex-start;
                flex-flow: row wrap;
                padding-top: 0;
                .table-container{
                    padding: 10px;
                }
                .el-row {
                    width: 100%;
                }
            }
            .market-table.loading {
                color: #A7A7A7;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 20px 0;
                .el-icon-loading {
                    margin-right: 10px;
                }
                .el-icon-loading:before {
                    font-size: 30px;
                }

            }
        }
    }

    @media screen and (max-width: 680px) {
        .market-page{
            .el-main{
                padding: 15px 5px;
            }
        }
    }

    @media screen and (max-width: 420px) {
        .market-page{
            .el-main{
                padding: 15px 2px;
                .market-table{
                    padding: 5px 0;
                    width: 100%;
                    .el-row{
                        width: 100%;        
                    }
                    .table-container{
                        padding: 10px 0;
                        width: 100%;
                        overflow-y: scroll;
                        table tr{
                            td{
                                padding: 10px 0px;
                                font-size: 0.3rem;
                            }
                            .td-min-width{
                                min-width: 90px;
                            }
                        }
                    }
                    .table-container::-webkit-scrollbar {
                        width: 0 !important;
                    }
                    .table-container {
                        -ms-overflow-style: none;
                        overflow: -moz-scrollbars-none;
                    }
                }
                .market-title{
                    padding: 5px;
                    h3{
                        font-size: 13px;
                    }
                    .title-btn{
                        // margin-left: 40px;
                        select{
                            font-size: 12px;
                            padding: 2px;
                            margin-left: 5px;
                        }
                        .el-button{
                            margin-left: 5px;
                            padding: 5px;
                            span{
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
